var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectCreateUser',{attrs:{"height":_vm.height,"clearable":true},model:{value:(_vm.inputedValue),callback:function ($$v) {_vm.inputedValue=$$v},expression:"inputedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }